import { faSearch } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import Input from '../../../../../../../components/input/input';

import './styles.scss';

type OtcTraderSearchInputProps = {
  searchValue: string;
  setSearchValue: React.Dispatch<React.SetStateAction<string>>;
};

export const OtcTraderSearchInput: React.FC<OtcTraderSearchInputProps> = ({
  searchValue,
  setSearchValue,
}) => {
  return (
    <Input
      icon={<FontAwesomeIcon icon={faSearch} />}
      placeholder="Search"
      value={searchValue}
      onChange={(e) => setSearchValue(e.target.value)}
      autoFocus
      className="otc-trader-search-input"
    />
  );
};
